/**
 * Generated by orval v8.21.0 🍺
 * Do not edit manually.
 * Kreditportal Backend API
 * Das Kreditportal ermöglicht Versicherungsnehmern die Kautionsverträge einzusehen, anzupassen und Bürgschaften zu beantragen. Diese API ist eine Middleware fürs Frontend zu den Backend-Systemen.
 * OpenAPI spec version: 4.0.6-FINAL
 */
import type { HttpContext, HttpEvent, HttpParams } from '@angular/common/http';
import { HttpClient, HttpHeaders, HttpResponse as AngularHttpResponse } from '@angular/common/http';

import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import type {
    GetNachrichtenByVsnrsParams,
    Nachricht,
    NachrichtenSimpleResponse,
    SetGelesenStatusParams
} from '../kreditportalBackendAPI.schemas';


interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value.filter(
        (item) =>
          item != null &&
          (typeof item === 'string' ||
            typeof item === 'number' ||
            typeof item === 'boolean'),
      ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (
      preserveRequiredNullables &&
      value === null &&
      requiredNullableKeys.has(key)
    ) {
      filteredParams[key] = null;
    } else if (
      value != null &&
      (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}





@Injectable({ providedIn: 'root' })
export class NachrichtenApiService {
  private readonly http = inject(HttpClient);
/**
 * Mit diesem Service kann für eine Nachricht anhand der ID der (Nicht-)Gelesen-Status gesetzt werden.
 * @summary Setze Gelesen-Status für eine Nachricht
 */
 setGelesenStatus<TData = Nachricht>(nachrichtId: number,
    params: SetGelesenStatusParams, options?: HttpClientBodyOptions): Observable<TData>;
 setGelesenStatus<TData = Nachricht>(nachrichtId: number,
    params: SetGelesenStatusParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 setGelesenStatus<TData = Nachricht>(nachrichtId: number,
    params: SetGelesenStatusParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  setGelesenStatus<TData = Nachricht>(
    nachrichtId: number,
    params: SetGelesenStatusParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.patch<TData>(
      `/api/nachrichten/${nachrichtId}/gelesen`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(
      `/api/nachrichten/${nachrichtId}/gelesen`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.patch<TData>(
      `/api/nachrichten/${nachrichtId}/gelesen`,
      undefined,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
/**
 * Mit diesem Service kann eine einzelne Nachricht anhand einer ID abgerufen werden.
 * @summary Nachricht anhand einer ID abrufen
 */
 getNachrichtenById<TData = Nachricht>(nachrichtId: number, options?: HttpClientBodyOptions): Observable<TData>;
 getNachrichtenById<TData = Nachricht>(nachrichtId: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getNachrichtenById<TData = Nachricht>(nachrichtId: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getNachrichtenById<TData = Nachricht>(
    nachrichtId: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/nachrichten/${nachrichtId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/nachrichten/${nachrichtId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/nachrichten/${nachrichtId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Mit diesem Service kann eine Nachricht anhand der ID gelöscht werden.
 * @summary Lösche Nachricht
 */
 deleteNachrichten<TData = Nachricht>(nachrichtId: number, options?: HttpClientBodyOptions): Observable<TData>;
 deleteNachrichten<TData = Nachricht>(nachrichtId: number, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 deleteNachrichten<TData = Nachricht>(nachrichtId: number, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  deleteNachrichten<TData = Nachricht>(
    nachrichtId: number, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `/api/nachrichten/${nachrichtId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `/api/nachrichten/${nachrichtId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `/api/nachrichten/${nachrichtId}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Mit diesem Service können alle Nachrichten (eines Kunden; im Kurzformat) anhand der Versicherungsscheinnummern (VSNR) abgerufen werden.
 * @summary Nachrichten anhand der VSNRs abrufen
 */
 getNachrichtenByVsnrs<TData = NachrichtenSimpleResponse>(params?: GetNachrichtenByVsnrsParams, options?: HttpClientBodyOptions): Observable<TData>;
 getNachrichtenByVsnrs<TData = NachrichtenSimpleResponse>(params?: GetNachrichtenByVsnrsParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getNachrichtenByVsnrs<TData = NachrichtenSimpleResponse>(params?: GetNachrichtenByVsnrsParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getNachrichtenByVsnrs<TData = NachrichtenSimpleResponse>(
    params?: GetNachrichtenByVsnrsParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/nachrichten/byVsnrs`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/nachrichten/byVsnrs`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/api/nachrichten/byVsnrs`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
};

